import Component from '@lunaweb/vega-reactor-js/src/patterns/Component';

export default class Subsubmenu extends Component {
  static settings = {
    close: ".js-subsub-back-submenu",
  };

  #collapseItem;
  lastFocusedElement = null;
  #closeButtons;
  #sentinels = [];
  #subsubItem;
  #subsubspace;
  #focusCheckInterval = null;

  constructor(element, options = {}) {
    super(element, {
      ...Subsubmenu.settings,
      ...options,
    });

    this.#collapseItem = this.element.querySelectorAll('.js-subsub-havechild');
    this.#closeButtons = this.element.querySelectorAll('.js-subsub-back-submenu');
    this.#sentinels = Array.from(this.element.querySelectorAll('.js-subsub-sentinel'));

    this.#collapseItem.forEach((collapse) => {
      const opener = collapse.querySelector('.js-subsub-opener');
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
      }
    });
  }

  mount() {
    super.mount();
    this.hideAllSubsubs();
    this.bindOpeners();
    this.bindSentinels();

    this._onKeydown = (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    };

    this.#closeButtons.forEach((close) => {
      close.addEventListener('click', () => {
        this.close();
      });
    });

    document.addEventListener('keydown', this._onKeydown);
  }

  unmount() {
    document.removeEventListener('keydown', this._onKeydown);
    this.#sentinels.forEach(sentinel => {
      sentinel.removeEventListener('focus', this._onSentinelFocus);
    });
    super.unmount();
  }

  bindSentinels() {
    this._onSentinelFocus = (e) => {
      const sentinel = e.target;
      const subsubspace = sentinel.closest('.c-navigation__subsubspace');

      if (subsubspace && subsubspace.classList.contains('open')) {
        this.closeSubsubspace(subsubspace);
      }
    };

    this.#sentinels.forEach(sentinel => {
      sentinel.addEventListener('focus', this._onSentinelFocus);
    });
  }

  hideAllSubsubs() {
    const allSubsubspaces = this.element.querySelectorAll('.c-navigation__subsubspace');
    allSubsubspaces.forEach((subsubspace) => {
      subsubspace.classList.remove('open');
      subsubspace.classList.add('close');
      subsubspace.hidden = true;
    });

    this.removeActiveOpeners();
  }

  showSubsubspace(subsubspace) {
    subsubspace.hidden = false;
    subsubspace.classList.add('open');
    subsubspace.classList.remove('close');

    const firstFocusable = subsubspace.querySelector('a, button:not(.js-subsub-sentinel)');
    if (firstFocusable) {
      firstFocusable.focus();
    }

    this.subsubspaceSizes();
  }

  closeSubsubspace(subsubspace) {
    subsubspace.classList.remove('open');
    subsubspace.classList.add('close');
    subsubspace.hidden = true;

    const parentLi = subsubspace.closest('.js-subsub-havechild');
    if (parentLi) {
      const opener = parentLi.querySelector('.js-subsub-opener');
      if (opener) {
        opener.classList.remove('active');
        opener.setAttribute('aria-expanded', 'false');
        opener.focus();
      }
    }
  }

  removeActiveOpeners() {
    this.#collapseItem.forEach((collapse) => {
      const opener = collapse.querySelector('.js-subsub-opener');
      if (opener) {
        opener.classList.remove('active');
        opener.setAttribute('aria-expanded', 'false');
      }
    });
  }

  close() {
    const activeSubsubspace = this.element.querySelector('.c-navigation__subsubspace.open');

    if (activeSubsubspace) {
      this.closeSubsubspace(activeSubsubspace);
    }
  }

  toggleTarget(opener, subsubspace) {
    const isVisible = subsubspace.classList.contains('open');

    if (isVisible) {
      this.closeSubsubspace(subsubspace);
    } else {
      this.hideAllSubsubs();
      opener.classList.add('active');
      opener.setAttribute('aria-expanded', 'true');
      this.showSubsubspace(subsubspace);
    }
  }

  subsubspaceSizes() {
    const subsubspaces = this.element.querySelectorAll('.c-navigation__subsubspace');
    let maxHeight = 0;
    let subspace = null;

    if (!subsubspaces.length) return;

    subsubspaces.forEach((subsubspace) => {
      const wasHidden = subsubspace.hidden;
      if (wasHidden) subsubspace.hidden = false;

      const rect = subsubspace.getBoundingClientRect();
      const height = rect.height;

      if (!subspace) subspace = subsubspace.closest('.c-navigation__subspace');
      if (height > maxHeight) maxHeight = height;

      if (wasHidden) subsubspace.hidden = true;
    });

    if (subspace) {
      const currentHeight = subspace.getBoundingClientRect().height;
      if (maxHeight > currentHeight) subspace.style.height = `${maxHeight}px`;
    }
  }

bindOpeners() {
  this.#collapseItem.forEach((collapse) => {
    const opener = collapse.querySelector('.js-subsub-opener');
    const subsubspace = collapse.querySelector('.c-navigation__subsubspace');

    if (opener && subsubspace) {
      opener.addEventListener('click', () => {
        this.toggleTarget(opener, subsubspace);
      });

      // Nouvelle gestion focusout
      subsubspace.addEventListener('focusout', (e) => {
        const newFocus = e.relatedTarget;

        // Si le focus sort complètement du subsubspace
        if (!subsubspace.contains(newFocus)) {
          setTimeout(() => {
            if (subsubspace.classList.contains('open')) {
              this.closeSubsubspace(subsubspace);
            }
          }, 50);
        }
      });
    }
  });
}
}
